import { Skeleton } from '../../../../../Skeleton'
import { LISTING_READINESS_SKELETON_ROW_COUNT } from '../RentalPortalListingProfileWidgetPublishing.constants'

import * as styles from './ListingProfileWidgetPublishingSkeleton.module.css'

function ListingProfileWidgetPublishingSkeleton() {
  return (
    <div className={styles.ListingProfileWidgetPublishingSkeleton}>
      <Skeleton className={styles.status} />
      <Skeleton className={styles.count} />
      {Array.from({ length: LISTING_READINESS_SKELETON_ROW_COUNT }).map(
        (_, index) => (
          <div className={styles.row} key={index}>
            <Skeleton className={styles.marker} />
            <Skeleton className={styles.label} />
          </div>
        )
      )}
      <Skeleton className={styles.action} />
    </div>
  )
}

export default ListingProfileWidgetPublishingSkeleton
